import React from 'react';

import _get from 'lodash/get';

export const pickUserResponse = response => {
  const { username, email, rut, tenants, profile } = _get(response, 'data.user.data', {});
  const { unique_id } = _get(response, 'data.user', null);

  return {  unique_id,
    username,
    email: profile?.email || email,
    tenants,
    lastName: profile?.motherLastName,
    name: profile?.name,
    rut: profile?.rut || rut,
    firstName: profile?.fatherLastName,
    fullName: profile?.name ? `${profile.name} ${profile?.fatherLastName}` : username,
    profile,
  };
};

